import React, { useEffect } from 'react';
import { AboutSection, WhyChoose } from '../components/Sections';
import { trackPageLifecycle } from '../lib/customerEventTracker';

const About = () => {
  useEffect(
    () => trackPageLifecycle({
      funnel_name: 'ABOUT_PAGE',
      form_name: 'AboutPage',
      service_code: null,
      open_event_name: 'about_page_open',
    }),
    [],
  );

  return (
    <div className="pt-22">
      <AboutSection />
      <WhyChoose />
    </div>
  );
};

export default About;
